import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import Shearchbar from "./Shearchbar";
import Navbar from "./Navbar";
import Manubar from "./Manubar";
import "./TrackOrder.css";

const TrackOrder = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const initialOrderData = location.state?.orderData || {};
  const [orderData, setOrderData] = useState(initialOrderData);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const _id = secureLocalStorage.getItem("n_id");

  const isCancelled = orderData.order_status === "Cancelled" || orderData.order_status === "Cancel";

  const statusRank = {
    placed: 1,
    Accepted: 2,
    Shipped: 3,
    Delivered: 4,
  };

  const trackingSteps = [
    {
      title: "Order Placed",
      description: "Your Order has been placed",
      date: orderData.order_date,
      stepKey: 1,
    },
    {
      title: "Accepted",
      description: "Your order has been accepted",
      date: orderData.accepted_date,
      stepKey: 2,
    },
    {
      title: "Shipped",
      description: "Your order has been shipped",
      date: orderData.couriered_date || orderData.in_transit_date,
      stepKey: 3,
    },
    {
      title: "Delivered",
      description: "Your order has been delivered",
      date: orderData.completed_date,
      stepKey: 4,
    },
  ];

  const currentRank = statusRank[orderData.order_status];

  useEffect(() => {
    const fetchTrackOrder = async () => {
      try {
        const order_id = initialOrderData?.order_id;

        if (!order_id) return;

        const data = { order_id };

        const response = await axios.post(
          `${process.env.REACT_APP_API}website/track_my_order`,
          data,
        );

        if (response.data.result === "true") {
          const orderDetails = response.data.data[0];
          const product = orderDetails.products?.[0];

          setOrderData({
            ...orderDetails,
            product_name: product?.product_title,
            product_price: product?.sale_price,
            product_image: product?.product_image,
          });
        }
      } catch (error) {
        console.error("Track order error:", error);
      }
    };

    fetchTrackOrder();
  }, [initialOrderData?.order_id]);

  const handleCancelOrder = async () => {
    if (!cancelReason.trim()) {
      alert("Please provide a reason for cancellation");
      return;
    }

    try {
      let data = {
        order_id: orderData.order_id || orderData._id,
        user_id: _id,
        order_status: "Cancelled",
        region: cancelReason,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API}website/cancel_order`,
        data,
      );

      if (response.data.result) {
        alert("Order cancelled successfully!");
        navigate("/myOrders");
      } else {
        alert(response.data.message || "Failed to cancel order");
      }
    } catch (error) {
      console.error("Error cancelling order:", error);
      alert("Failed to cancel order");
    }
  };

  const canCancel =
    !isCancelled &&
    orderData.order_status !== "Delivered" &&
    orderData.order_status !== "Completed";

  return (
    <section
        className="new-arrival-carousel-section"
        style={{ marginBottom: "40px" }}
      >
    <div className="my-orders-container">
      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Manubar />
          </div>
        </div>
      </div>

      <header>
        <Shearchbar />

        <Navbar />
      </header>
      {/* Header */}
      <div className="track-order-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          <i className="las la-arrow-left"></i>
        </button>
        <h2>Track Order</h2>
      </div>

      {/* Order Date */}
      <div className="order-date-section">
        <span className="order-date-label">Order Date</span>
        <span className="order-date-value">
          {orderData.order_date || "16 February, 2026 4:14 PM"}
        </span>
      </div>

      {/* My Order Section */}
      <div className="my-order-section">
        <h3>My Order</h3>
        <div className="order-product-card">
          <div className="product-image-wrapper">
            <img
              src={`${process.env.REACT_APP_API}uploads/${orderData.product_image}`}
              alt={orderData.product_name}
              onError={(e) => {
                e.target.src = "/placeholder.png";
              }}
            />
          </div>
          <div className="product-info">
            <h4>{orderData.product_name || "Ruby - 5.78 carat"}</h4>
            <p className="product-price">₹ {orderData.grand_total}</p>
            {orderData.available_status && (
              <span className="product-type-badge">
                {orderData.available_status}
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Order Summary */}
      <div className="order-summary-card">
        <div className="order-summary-content">
          <p className="order-number-text">
            Order No. :{" "}
            <span className="order-number-value">
              #{orderData.order_no || "460823"}
            </span>
          </p>
          <p className="order-items-text">
            {orderData.product_count || 1} Item{" "}
            <span className="order-total-amount">₹{orderData.grand_total}</span>
          </p>
        </div>
      </div>

      {/* Cancelled Status Banner */}
      {isCancelled && (
        <div className="cancelled-banner">
          <i className="las la-times-circle"></i>
          <span>Order Cancelled</span>
          {orderData.cancel_date && (
            <span className="cancelled-date">on {orderData.cancel_date}</span>
          )}
        </div>
      )}

      {/* Tracking Timeline - Only show if not cancelled */}
      {!isCancelled && (
        <div className="tracking-timeline">
          {trackingSteps.map((step, index) => {
            const isCompleted = currentRank >= step.stepKey;

            return (
              <div
                key={index}
                className={`timeline-step ${
                  isCompleted ? "completed" : "pending"
                }`}
              >
                <div className="timeline-icon">
                  {isCompleted ? (
                    <i className="las la-check"></i>
                  ) : (
                    <div className="pending-dot"></div>
                  )}
                </div>

                <div className="timeline-content">
                  <h4>{step.title}</h4>
                </div>
              </div>
            );
          })}
        </div>
      )}

      <div className="order-price-section">
        <span className="order-price-label">Total Price</span>
        <span className="order-price-value">₹{orderData.grand_total}</span>
      </div>

      {/* Cancel Order Button */}
      {canCancel && (
        <div className="cancel-order-section">
          <button
            className="cancel-order-btn"
            onClick={() => setShowCancelModal(true)}
          >
            Cancel Order
          </button>
        </div>
      )}

      {/* Cancel Order Modal */}
      {showCancelModal && (
        <div
          className="cancel-modal-overlay"
          onClick={() => setShowCancelModal(false)}
        >
          <div className="cancel-modal" onClick={(e) => e.stopPropagation()}>
            <div className="cancel-modal-header">
              <button
                className="back-button"
                onClick={() => setShowCancelModal(false)}
              >
                <i className="las la-arrow-left"></i>
              </button>
              <h2>Cancel Order</h2>
            </div>

            <div className="cancel-modal-content">
              <p className="cancel-order-date">
                Order Date:{" "}
                {orderData.order_date || "16 February, 2026 4:14 PM"}
              </p>

              <div className="cancel-product-info">
                <h4>{orderData.product_name || "Ruby - 5.78 carat"}</h4>
                <p>Qty: {orderData.product_count || 1}</p>
                <p className="cancel-product-price">
                  ₹{" "}
                  {orderData.grand_total || orderData.product_price || "18,591"}
                </p>
              </div>

              <div className="cancel-reason-section">
                <label>Reason for cancelling order</label>
                <textarea
                  value={cancelReason}
                  onChange={(e) => setCancelReason(e.target.value)}
                  placeholder="Enter reason for cancellation..."
                  rows="5"
                />
              </div>

              <button className="submit-cancel-btn" onClick={handleCancelOrder}>
                Cancel Order
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    </section>
  );
};

export default TrackOrder;
